<div class="panel panel-default">
  <div class="panel-heading">
    <b>All Done!</b>
  </div>
  <div class="panel-body">
    <help-button field="complete_header" [showText]="true"></help-button>
    Update Application: <a style="text-decoration: none;" [routerLink]="['/', 'application', route.parent.snapshot.params.type, firstPage.item]">
    <button class="btn btn-default">
      <span *ngIf="!loading">Update</span>
      <span *ngIf="loading"><i class="fa fa-spinner fa-pulse"></i> </span>
    </button>
  </a>
    <br/><br/>
    <!--    todo: worry about this when we get to noa-->
    <!--    <a *ngIf="currentPage.route === 'pesticides/noaapplications'" style="text-decoration: none;"-->
    <!--       href="/api-v1/{{ currentPage.route }}/{{ application.attributes.globalid }}/download_excel/" target="_blank">-->
    <!--      Download Products Excel File-->
    <!--    </a>-->
  </div>
</div>
<div class="row panel" style="padding: 0; width: 849px" *ngIf="currentPage?.hasOwnProperty('getPrintUrl')">
  <div class="col-md-12" style="display: flex; justify-content: center; align-items: center; padding: 0;">
    <span *ngIf="loading" style="width: 100%; position: absolute; left: 46%"><i class="fa fa-spinner fa-pulse fa-5x"></i> </span>
    <object width="849" height="1000" id="output" (load)="dataLoaded($event)" (loadeddata)="dataLoaded($event)"
            [data]="currentPage?.getPrintUrl(application.attributes.globalid) | toTrusted:'url'"
            type="application/pdf"></object>
  </div>
</div>
